export const bankDetails = [
    { value: 1, bankname: "ABHYUDAYA COOPERATIVE BANK LIMITED" },
    { value: 2, bankname: "ABU DHABI COMMERCIAL BANK" },
    { value: 3, bankname: "AHMEDABAD MERCANTILE COOPERATIVE BANK" },
    { value: 4, bankname: "AKOLA JANATA COMMERCIAL COOPERATIVE BANK" },
    { value: 5, bankname: "ALLAHABAD BANK" },
    { value: 6, bankname: "ALMORA URBAN COOPERATIVE BANK LIMITED" },
    { value: 7, bankname: "ANDHRA BANK" },
    { value: 8, bankname: "ANDHRA PRAGATHI GRAMEENA BANK" },
    { value: 9, bankname: "APNA SAHAKARI BANK LIMITED" },
    { value: 10, bankname: "AUSTRALIA AND NEW ZEALAND BANKING GROUP LIMITED" },
    { value: 11, bankname: "AXIS BANK" },
    { value: 12, bankname: "B N P PARIBAS" },
    { value: 13, bankname: "BANDHAN BANK LIMITED" },
    { value: 14, bankname: "BANK OF AMERICA" },
    { value: 15, bankname: "BANK OF BAHARAIN AND KUWAIT BSC" },
    { value: 16, bankname: "BANK OF BARODA" },
    { value: 17, bankname: "BANK OF CEYLON" },
    { value: 18, bankname: "BANK OF INDIA" },
    { value: 19, bankname: "BANK OF MAHARASHTRA" },
    { value: 20, bankname: "BANK OF TOKYO MITSUBISHI LIMITED" },
    { value: 21, bankname: "BARCLAYS BANK" },
    { value: 22, bankname: "BASSEIN CATHOLIC COOPERATIVE BANK LIMITED" },
    { value: 23, bankname: "BHARAT COOPERATIVE BANK MUMBAI LIMITED" },
    { value: 24, bankname: "BHARATIYA MAHILA BANK LIMITED" },
    { value: 25, bankname: "CANARA BANK" },
    { value: 26, bankname: "CAPITAL LOCAL AREA BANK LIMITED" },
    { value: 27, bankname: "CATHOLIC SYRIAN BANK LIMITED" },
    { value: 28, bankname: "CENTRAL BANK OF INDIA" },
    { value: 29, bankname: "CHINATRUST COMMERCIAL BANK LIMITED" },
    { value: 30, bankname: "CITI BANK" },
    { value: 31, bankname: "CITIZEN CREDIT COOPERATIVE BANK LIMITED" },
    { value: 32, bankname: "CITY UNION BANK LIMITED" },
    { value: 33, bankname: "COMMONWEALTH BANK OF AUSTRALIA" },
    { value: 34, bankname: "CORPORATION BANK" },
    {
      value: 35,
      bankname: "CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK CALYON BANK",
    },
    { value: 36, bankname: "CREDIT SUISEE AG" },
    { value: 37, bankname: "DCB BANK LIMITED" },
    { value: 38, bankname: "DENA BANK" },
    { value: 39, bankname: "DEOGIRI NAGARI SAHAKARI BANK LTD. AURANGABAD" },
    { value: 40, bankname: "DEPOSIT INSURANCE AND CREDIT GUARANTEE CORPORATION" },
    { value: 41, bankname: "DEUSTCHE BANK" },
    { value: 42, bankname: "DEVELOPMENT BANK OF SINGAPORE" },
    { value: 43, bankname: "DHANALAKSHMI BANK" },
    { value: 44, bankname: "DOHA BANK QSC" },
    { value: 45, bankname: "DOMBIVLI NAGARI SAHAKARI BANK LIMITED" },
    { value: 46, bankname: "EXPORT IMPORT BANK OF INDIA" },
    { value: 47, bankname: "FEDERAL BANK" },
    { value: 48, bankname: "FIRSTRAND BANK LIMITED" },
    { value: 49, bankname: "G P PARSIK BANK" },
    { value: 50, bankname: "HDFC BANK" },
    { value: 51, bankname: "HIMACHAL PRADESH STATE COOPERATIVE BANK LTD" },
    { value: 52, bankname: "HSBC BANK" },
    { value: 53, bankname: "ICICI BANK LIMITED" },
    { value: 54, bankname: "IDBI BANK" },
    { value: 55, bankname: "IDFC BANK LIMITED" },
    { value: 56, bankname: "INDIAN BANK" },
    { value: 57, bankname: "INDIAN OVERSEAS BANK" },
    { value: 58, bankname: "INDUSIND BANK" },
    { value: 59, bankname: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED" },
    { value: 60, bankname: "INDUSTRIAL BANK OF KOREA" },
    { value: 61, bankname: "ING VYSYA BANK" },
    { value: 62, bankname: "JALGAON JANATA SAHAKARI BANK LIMITED" },
    { value: 63, bankname: "JAMMU AND KASHMIR BANK LIMITED" },
    { value: 64, bankname: "JANAKALYAN SAHAKARI BANK LIMITED" },
    { value: 65, bankname: "JANASEVA SAHAKARI BANK BORIVLI LIMITED" },
    { value: 66, bankname: "JANASEVA SAHAKARI BANK LIMITED" },
    { value: 67, bankname: "JANATA SAHAKARI BANK LIMITED" },
    { value: 68, bankname: "JP MORGAN BANK" },
    {
      value: 69,
      bankname: "KALLAPPANNA AWADE ICHALKARANJI JANATA SAHAKARI BANK LTD",
    },
    { value: 70, bankname: "KALUPUR COMMERCIAL COOPERATIVE BANK" },
    { value: 71, bankname: "KALYAN JANATA SAHAKARI BANK" },
    { value: 72, bankname: "KAPOL COOPERATIVE BANK LIMITED" },
    { value: 73, bankname: "KARNATAKA BANK LIMITED" },
    { value: 74, bankname: "KARNATAKA VIKAS GRAMEENA BANK" },
    { value: 75, bankname: "KARUR VYSYA BANK" },
    { value: 76, bankname: "KEB Hana Bank" },
    { value: 77, bankname: "KERALA GRAMIN BANK" },
    { value: 78, bankname: "KOTAK MAHINDRA BANK LIMITED" },
    { value: 79, bankname: "LAXMI VILAS BANK" },
    { value: 80, bankname: "MAHANAGAR COOPERATIVE BANK" },
    { value: 81, bankname: "MAHARASHTRA STATE COOPERATIVE BANK" },
    { value: 82, bankname: "MASHREQBANK PSC" },
    { value: 83, bankname: "MIZUHO CORPORATE BANK LIMITED" },
    { value: 84, bankname: "NAGAR URBAN CO OPERATIVE BANK" },
    { value: 85, bankname: "NAGPUR NAGARIK SAHAKARI BANK LIMITED" },
    { value: 86, bankname: "NATIONAL AUSTRALIA BANK LIMITED" },
    { value: 87, bankname: "NATIONAL BANK OF ABU DHABI PJSC" },
    { value: 88, bankname: "NEW INDIA COOPERATIVE BANK LIMITED" },
    { value: 89, bankname: "NKGSB COOPERATIVE BANK LIMITED" },
    { value: 90, bankname: "NUTAN NAGARIK SAHAKARI BANK LIMITED" },
    { value: 91, bankname: "ORIENTAL BANK OF COMMERCE" },
    { value: 92, bankname: "PRAGATHI KRISHNA GRAMIN BANK" },
    { value: 93, bankname: "PRATHAMA BANK" },
    { value: 94, bankname: "PRIME COOPERATIVE BANK LIMITED" },
    { value: 95, bankname: "PT BANK MAYBANK INDONESIA TBK" },
    { value: 96, bankname: "PUNJAB AND MAHARSHTRA COOPERATIVE BANK" },
    { value: 97, bankname: "PUNJAB AND SIND BANK" },
    { value: 98, bankname: "PUNJAB NATIONAL BANK" },
    { value: 99, bankname: "RABOBANK INTERNATIONAL" },
    { value: 100, bankname: "RAJGURUNAGAR SAHAKARI BANK LIMITED" },
    { value: 101, bankname: "RAJKOT NAGRIK SAHAKARI BANK LIMITED" },
    { value: 102, bankname: "RBL Bank Limited" },
    { value: 103, bankname: "RESERVE BANK OF INDIA" },
    { value: 104, bankname: "SAHEBRAO DESHMUKH COOPERATIVE BANK LIMITED" },
    { value: 105, bankname: "SAMARTH SAHAKARI BANK LTD" },
    { value: 106, bankname: "SARASWAT COOPERATIVE BANK LIMITED" },
    { value: 107, bankname: "SBER BANK" },
    { value: 108, bankname: "SBM BANK MAURITIUS LIMITED" },
    { value: 109, bankname: "SHIKSHAK SAHAKARI BANK LIMITED" },
    { value: 110, bankname: "SHINHAN BANK" },
    { value: 111, bankname: "SHIVALIK MERCANTILE CO OPERATIVE BANK LTD" },
    {
      value: 112,
      bankname: "SHRI CHHATRAPATI RAJASHRI SHAHU URBAN COOPERATIVE BANK LTD",
    },
    { value: 113, bankname: "SOCIETE GENERALE" },
    { value: 114, bankname: "SOLAPUR JANATA SAHAKARI BANK LIMITED" },
    { value: 115, bankname: "SOUTH INDIAN BANK" },
    { value: 116, bankname: "STANDARD CHARTERED BANK" },
    { value: 117, bankname: "STATE BANK OF BIKANER AND JAIPUR" },
    { value: 118, bankname: "STATE BANK OF HYDERABAD" },
    { value: 119, bankname: "STATE BANK OF INDIA" },
    { value: 120, bankname: "STATE BANK OF MYSORE" },
    { value: 121, bankname: "STATE BANK OF PATIALA" },
    { value: 122, bankname: "STATE BANK OF TRAVANCORE" },
    { value: 123, bankname: "SUMITOMO MITSUI BANKING CORPORATION" },
    { value: 124, bankname: "SURAT NATIONAL COOPERATIVE BANK LIMITED" },
    { value: 125, bankname: "SUTEX COOPERATIVE BANK LIMITED" },
    { value: 126, bankname: "SYNDICATE BANK" },
    { value: 127, bankname: "TAMILNAD MERCANTILE BANK LIMITED" },
    { value: 128, bankname: "THE A.P. MAHESH COOPERATIVE URBAN BANK LIMITED" },
    { value: 129, bankname: "THE AKOLA DISTRICT CENTRAL COOPERATIVE BANK" },
    { value: 130, bankname: "THE ANDHRA PRADESH STATE COOPERATIVE BANK LIMITED" },
    { value: 131, bankname: "THE BANK OF NOVA SCOTIA" },
    { value: 132, bankname: "THE COSMOS CO OPERATIVE BANK LIMITED" },
    { value: 133, bankname: "THE DELHI STATE COOPERATIVE BANK LIMITED" },
    {
      value: 134,
      bankname: "THE GADCHIROLI DISTRICT CENTRAL COOPERATIVE BANK LIMITED",
    },
    { value: 135, bankname: "THE GREATER BOMBAY COOPERATIVE BANK LIMITED" },
    { value: 136, bankname: "THE GUJARAT STATE COOPERATIVE BANK LIMITED" },
    { value: 137, bankname: "THE HASTI COOP BANK LTD" },
    { value: 138, bankname: "THE JALGAON PEOPELS COOPERATIVE BANK LIMITED" },
    { value: 139, bankname: "THE KANGRA CENTRAL COOPERATIVE BANK LIMITED" },
    { value: 140, bankname: "THE KANGRA COOPERATIVE BANK LIMITED" },
    { value: 141, bankname: "THE KARAD URBAN COOPERATIVE BANK LIMITED" },
    {
      value: 142,
      bankname: "THE KARANATAKA STATE COOPERATIVE APEX BANK LIMITED",
    },
    { value: 143, bankname: "THE KURMANCHAL NAGAR SAHAKARI BANK LIMITED" },
    { value: 144, bankname: "THE MEHSANA URBAN COOPERATIVE BANK" },
    {
      value: 145,
      bankname: "THE MUMBAI DISTRICT CENTRAL COOPERATIVE BANK LIMITED",
    },
    { value: 146, bankname: "THE MUNICIPAL COOPERATIVE BANK LIMITED" },
    { value: 147, bankname: "THE NAINITAL BANK LIMITED" },
    { value: 148, bankname: "THE NASIK MERCHANTS COOPERATIVE BANK LIMITED" },
    { value: 149, bankname: "THE PANDHARPUR URBAN CO OP. BANK LTD. PANDHARPUR" },
    { value: 150, bankname: "THE RAJASTHAN STATE COOPERATIVE BANK LIMITED" },
    { value: 151, bankname: "THE ROYAL BANK OF SCOTLAND N V" },
    { value: 152, bankname: "THE SEVA VIKAS COOPERATIVE BANK LIMITED" },
    { value: 153, bankname: "THE SHAMRAO VITHAL COOPERATIVE BANK" },
    { value: 154, bankname: "THE SURAT DISTRICT COOPERATIVE BANK LIMITED" },
    { value: 155, bankname: "THE SURATH PEOPLES COOPERATIVE BANK LIMITED" },
    { value: 156, bankname: "THE TAMIL NADU STATE APEX COOPERATIVE BANK" },
    { value: 157, bankname: "THE THANE BHARAT SAHAKARI BANK LIMITED" },
    {
      value: 158,
      bankname: "THE THANE DISTRICT CENTRAL COOPERATIVE BANK LIMITED",
    },
    { value: 159, bankname: "THE VARACHHA COOPERATIVE BANK LIMITED" },
    { value: 160, bankname: "THE VISHWESHWAR SAHAKARI BANK LIMITED" },
    { value: 161, bankname: "THE WEST BENGAL STATE COOPERATIVE BANK" },
    { value: 162, bankname: "THE ZOROASTRIAN COOPERATIVE BANK LIMITED" },
    { value: 163, bankname: "TJSB SAHAKARI BANK LTD" },
    { value: 164, bankname: "TUMKUR GRAIN MERCHANTS COOPERATIVE BANK LIMITED" },
    { value: 165, bankname: "UCO BANK" },
    { value: 166, bankname: "UNION BANK OF INDIA" },
    { value: 167, bankname: "UNITED BANK OF INDIA" },
    { value: 168, bankname: "UNITED OVERSEAS BANK LIMITED" },
    { value: 169, bankname: "VASAI VIKAS SAHAKARI BANK LIMITED" },
    { value: 170, bankname: "VIJAYA BANK" },
    { value: 171, bankname: "WESTPAC BANKING CORPORATION" },
    { value: 172, bankname: "WOORI BANK" },
    { value: 173, bankname: "YES BANK" },
    { value: 174, bankname: "ZILA SAHAKRI BANK LIMITED GHAZIABAD" },
    { value: 175, bankname: "OTHERS" },
  ];